import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=19f709b5&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=19f709b5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f709b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f709b5')) {
      api.createRecord('19f709b5', component.options)
    } else {
      api.reload('19f709b5', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=19f709b5&scoped=true", function () {
      api.rerender('19f709b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/banner.vue"
export default component.exports